/*
 * ================================================================
 * URLS DES API (source unique)
 * ================================================================
 *
 * Les valeurs viennent exclusivement des fichiers d'environnement lus par
 * react-scripts au démarrage :
 *   - npm start        -> .env.local       (API Gateway locale : http://localhost:8080/...)
 *   - npm run build    -> .env.production  (https://gateway.assiganto-agro.com/...)
 *
 * Aucune URL de repli n'est codée en dur : une variable absente est signalée
 * explicitement au lieu d'envoyer silencieusement les appels vers la production.
 * Après modification d'un fichier .env*, redémarrer `npm start`.
 * ================================================================
 */

const readUrl = name => {
    const value = process.env[name];
    if (!value) {
        const message =
            `Variable d'environnement ${name} absente : ajoutez-la à .env.local ` +
            "(local) ou .env.production (build), puis redémarrez `npm start`.";
        if (process.env.NODE_ENV === "test") {
            return "";
        }
        console.error(message);
        throw new Error(message);
    }
    return value.replace(/\/+$/, "");
};

/** agri-product-platform (marketplace, conversations, agreements, paiements). */
export const MARKETPLACE_API_URL = readUrl("REACT_APP_MARKETPLACE_PRODUCT_API_URL");

/** tenant-management (authentification, tenants). */
export const LOGIN_API_URL = readUrl("REACT_APP_LOGIN_API_BASE_URL");

/**
 * schema-based-tenant-registration via la gateway (nouveau lien « choisir mon mot de passe »).
 * Par défaut : la gateway de LOGIN_API_URL, chemin /registration/representant.
 */
export const REGISTRATION_API_URL = (process.env.REACT_APP_REGISTRATION_API_BASE_URL || "").replace(/\/+$/, "")
    || LOGIN_API_URL.replace(/\/tenant-management$/, "/registration/representant");

/** pre-registration (inscription des représentants). */
export const PRE_REGISTRATION_API_URL = readUrl("REACT_APP_PRE_REGISTRATION_API_BASE_URL");

/** agri-farming-operations-platform (offres de travaux champêtres publiques). */
export const FARMING_OPERATIONS_API_URL = readUrl("REACT_APP_FARMING_OPERATIONS_API_URL");

/** assiganto-commercial-financial-platform (référentiel, catalogue des offres, abonnements, factures). */
export const COMMERCIAL_FINANCIAL_API_URL = readUrl("REACT_APP_COMMERCIAL_FINANCIAL_API_URL");

/**
 * sales-and-market-tracking (négoce : stocks des négociants, demandes d'achat, page /traders).
 * Par défaut : la gateway de LOGIN_API_URL, chemin /sales-and-market-tracking.
 */
export const TRADING_API_URL = (process.env.REACT_APP_TRADING_API_URL || "").replace(/\/+$/, "")
    || LOGIN_API_URL.replace(/\/tenant-management$/, "/sales-and-market-tracking");
